document.addEventListener("DOMContentLoaded", () => {
  const previewModal = document.getElementById("preview-modal");
  const previewImage = document.getElementById("design-preview-image");
  const closePreviewBtn = document.getElementById("close-preview-btn");
  const downloadImageBtn = document.getElementById("download-image-btn");


  // --- Preview Modal Functions ---
  const showPreview = (imageDataUrl,discDesignDataUrlType) => {
    previewImage.classList.add("design-preview");

   

    if (discDesignDataUrlType === "External") {
      previewImage.classList.remove("design-preview");
    }

    previewImage.src = imageDataUrl;
    previewModal.classList.add("show");
    document.body.style.overflow = "hidden";
  };

  const hidePreview = () => {
    previewModal.classList.remove("show");
    document.body.style.overflow = "";
  };

  // --- Download Image Function ---

  const downloadImage = (imageUrl) => {
    try {
      const isSameOrigin = imageUrl.startsWith(window.location.origin);

      if (isSameOrigin) {
        // Force download for same-origin images
        const link = document.createElement("a");
        link.href = imageUrl;
        link.download = "image.png"; // Optional: extract file name from URL
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      } else {
        // Open third-party image in a new tab
        window.open(imageUrl, "_blank");
      }
    } catch (err) {
      console.error("⚠️ Failed to open or download image:", err);
      alert("Unable to download or open the image.");
    }
  };
  // --- Modal Event Listeners ---
  closePreviewBtn?.addEventListener("click", hidePreview);

  downloadImageBtn?.addEventListener("click", () => {
    downloadImage(previewImage.src);
  });

  // Close modal when clicking outside
  previewModal?.addEventListener("click", (e) => {
    if (e.target === previewModal) {
      hidePreview();
    }
  });

  // Close modal with Escape key
  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape" && previewModal.classList.contains("show")) {
      hidePreview();
    }
  });

 

  document.querySelectorAll(".view-dics-design-preview-link").forEach((link) => {
    link.addEventListener("click", function () {
      
      const wrapper = link.closest(".dics-design-preview-wrapper");
      const input = wrapper?.querySelector(".disc-design-data-url");
      const discDesignDataUrl = input?.value;

      const discDesignDataUrlType = document.getElementById(
        "disc-design-data-url-type"
      )?.value;

      if (discDesignDataUrl) {
        showPreview(discDesignDataUrl,discDesignDataUrlType);
      }
    });
  });
  
  document.querySelectorAll(".cart-view-dics-design-preview-link").forEach(link => {
    link.addEventListener("click", function () {
      const wrapper = this.closest(".dics-design-preview-wrapper");
      if (!wrapper) return; // safety check

      const discDesignDataUrl = wrapper.querySelector(".disc-design-data-url")?.value;
      const discDesignDataUrlType = wrapper.querySelector(".disc-design-data-url-type")?.value;
      

      if (discDesignDataUrl && typeof showPreview === "function") {
        showPreview(discDesignDataUrl, discDesignDataUrlType);
      }
    });
  });

  document
    .querySelectorAll(".cart-disc-preview-container")
    ?.forEach((container) => {
      const variantId = container.dataset.variantId;
      const designKey = `discDesign-${variantId}`;
      const designData = localStorage.getItem(designKey);

      if (designData) {
        const parsed = JSON.parse(designData);
        let dataURL = parsed.dataURL;
        const anchor = document.createElement("a");
        anchor.href = "javascript:void(0);";
        anchor.className = "";
        anchor.dataset.designkey = designKey;
        anchor.textContent = "View the created design";

        anchor.addEventListener("click", function () {
          showPreview(dataURL);
        });

        container.innerHTML = ""; // optional: clear existing content
        container.appendChild(anchor);
      }
    });
});
